import axios from "axios";
import {
  makeAutoObservable,
  action,
  observable,
  computed,
  runInAction,
} from "mobx";
import { get, eq } from "lodash";
import { AI_HOST, RequestState, defaultErrorMessage } from "../constants";

export class RecipeController {
  recipes = [];
  recipeRequestState = RequestState.IDLE;
  recipeMessage = "";

  constructor() {
    makeAutoObservable(this, {
      recipes: observable,
      recipeRequestState: observable,
      recipeMessage: observable,
      getRecipes: action,
      getRecipesList: computed,
      getRecipeRequestState: computed,
      getRecipeMessage: computed,
    });
  }

  async getRecipes(favoriteFoods, allergies, dietaryGoals) {
    runInAction(() => {
      this.recipeMessage = "";
      this.recipeRequestState = RequestState.REQUESTED;
    });

    try {
      const response = await axios.post(`${AI_HOST}/recipes/recommendations`, {
        favorite_foods: favoriteFoods,
        allergies: allergies,
        dietary_goals: dietaryGoals,
      });

      if (eq(response.status, 200)) {
        runInAction(() => {
          this.recipes = get(response, "data.recipes", []);
          this.recipeMessage = "";
        });
      } else {
        runInAction(() => {
          this.recipeMessage = get(
            response,
            "data.message",
            defaultErrorMessage
          );
        });
      }
    } catch (error) {
      console.log("Error fetching recipes", error);

      runInAction(() => {
        this.recipeMessage = get(
          error,
          "response.data.error",
          "Failed to fetch recipe recommendations. Please try again."
        );
      });
    }

    runInAction(() => {
      this.recipeRequestState = RequestState.RECEIVED;
    });
  }

  get getRecipesList() {
    return this.recipes;
  }

  get getRecipeRequestState() {
    return this.recipeRequestState;
  }

  get getRecipeMessage() {
    return this.recipeMessage;
  }
}
